module.exports = __webpack_public_path__ + "static/img/6.3558eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/6.png
// module id = 9WQ6
// module chunks = 1